export default {
    prefix: '',
    suffix: '',
    symbol: '',
    format: '%s%v',
    thousands: '',
    decimal: '.',
    precision: 2,
    maxlength: 8,
    masked: false
};
